"use client";
import { jsx as _jsx } from "react/jsx-runtime";
// import utils
import { styled } from "@mui/material/styles";
import shouldForwardProp from "../../../client-utils/styled/shouldForwardProp.util.js";
import { useEnvironmentContext } from "../../../components/providers/Environment/index.js";
const StyledImage = styled("img", {
    name: "SdbImage",
    slot: "Root",
    shouldForwardProp: shouldForwardProp("blackwhite"),
})(({ blackwhite }) => ({
    filter: blackwhite ? "grayscale(100%)" : "none",
}));
export const ImageAtomComponent = (props) => {
    const { components } = useEnvironmentContext();
    const Image = components?.Image ? components.Image : StyledImage;
    return _jsx(Image, { "data-testid": "Image", ...props });
};
export default ImageAtomComponent;
